import PropTypes from "prop-types";

const MediaLayout = ({ children, mediaNav }) => {
  return (
    <section className="scrollbar-hide relative rounded-[20px] border border-[#0075FF1A]">
      {mediaNav}
      <main className="scrollbar-hide relative pb-[72px]">{children}</main>
    </section>
  );
};

MediaLayout.propTypes = {
  children: PropTypes.node,
  mediaNav: PropTypes.node,
};

export default MediaLayout;
